"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Appstore", {
  enumerable: true,
  get: function get() {
    return _Appstore["default"];
  }
});
Object.defineProperty(exports, "ArrowDown", {
  enumerable: true,
  get: function get() {
    return _ArrowDown["default"];
  }
});
Object.defineProperty(exports, "ArrowLeft", {
  enumerable: true,
  get: function get() {
    return _ArrowLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowOnboarding", {
  enumerable: true,
  get: function get() {
    return _ArrowOnboarding["default"];
  }
});
Object.defineProperty(exports, "ArrowRight", {
  enumerable: true,
  get: function get() {
    return _ArrowRight["default"];
  }
});
Object.defineProperty(exports, "ArrowUp", {
  enumerable: true,
  get: function get() {
    return _ArrowUp["default"];
  }
});
Object.defineProperty(exports, "BeachLine1", {
  enumerable: true,
  get: function get() {
    return _BeachLine["default"];
  }
});
Object.defineProperty(exports, "BeachLine2", {
  enumerable: true,
  get: function get() {
    return _BeachLine2["default"];
  }
});
Object.defineProperty(exports, "BeachLine3", {
  enumerable: true,
  get: function get() {
    return _BeachLine3["default"];
  }
});
Object.defineProperty(exports, "BeachMixed", {
  enumerable: true,
  get: function get() {
    return _BeachMixed["default"];
  }
});
Object.defineProperty(exports, "BeachPebble", {
  enumerable: true,
  get: function get() {
    return _BeachPebble["default"];
  }
});
Object.defineProperty(exports, "BeachPlatform", {
  enumerable: true,
  get: function get() {
    return _BeachPlatform["default"];
  }
});
Object.defineProperty(exports, "BeachSand", {
  enumerable: true,
  get: function get() {
    return _BeachSand["default"];
  }
});
Object.defineProperty(exports, "BlackClock", {
  enumerable: true,
  get: function get() {
    return _BlackClock["default"];
  }
});
Object.defineProperty(exports, "Burger", {
  enumerable: true,
  get: function get() {
    return _Burger["default"];
  }
});
Object.defineProperty(exports, "CancellationOff", {
  enumerable: true,
  get: function get() {
    return _CancellationOff["default"];
  }
});
Object.defineProperty(exports, "CancellationOn", {
  enumerable: true,
  get: function get() {
    return _CancellationOn["default"];
  }
});
Object.defineProperty(exports, "CancellationQuestion", {
  enumerable: true,
  get: function get() {
    return _CancellationQuestion["default"];
  }
});
Object.defineProperty(exports, "Cashback", {
  enumerable: true,
  get: function get() {
    return _Cashback["default"];
  }
});
Object.defineProperty(exports, "CheckboxOff", {
  enumerable: true,
  get: function get() {
    return _CheckboxOff["default"];
  }
});
Object.defineProperty(exports, "CheckboxOn", {
  enumerable: true,
  get: function get() {
    return _CheckboxOn["default"];
  }
});
Object.defineProperty(exports, "ChevronCompactDown", {
  enumerable: true,
  get: function get() {
    return _ChevronCompactDown["default"];
  }
});
Object.defineProperty(exports, "ChevronCompactLeft", {
  enumerable: true,
  get: function get() {
    return _ChevronCompactLeft["default"];
  }
});
Object.defineProperty(exports, "ChevronCompactRight", {
  enumerable: true,
  get: function get() {
    return _ChevronCompactRight["default"];
  }
});
Object.defineProperty(exports, "ChevronCompactUp", {
  enumerable: true,
  get: function get() {
    return _ChevronCompactUp["default"];
  }
});
Object.defineProperty(exports, "ChevronDown", {
  enumerable: true,
  get: function get() {
    return _ChevronDown["default"];
  }
});
Object.defineProperty(exports, "ChevronLeft", {
  enumerable: true,
  get: function get() {
    return _ChevronLeft["default"];
  }
});
Object.defineProperty(exports, "ChevronRight", {
  enumerable: true,
  get: function get() {
    return _ChevronRight["default"];
  }
});
Object.defineProperty(exports, "ChevronUp", {
  enumerable: true,
  get: function get() {
    return _ChevronUp["default"];
  }
});
Object.defineProperty(exports, "Clock", {
  enumerable: true,
  get: function get() {
    return _Clock["default"];
  }
});
Object.defineProperty(exports, "Company", {
  enumerable: true,
  get: function get() {
    return _Company["default"];
  }
});
Object.defineProperty(exports, "Desktop", {
  enumerable: true,
  get: function get() {
    return _Desktop["default"];
  }
});
Object.defineProperty(exports, "Dislike", {
  enumerable: true,
  get: function get() {
    return _Dislike["default"];
  }
});
Object.defineProperty(exports, "DistanceToBeach", {
  enumerable: true,
  get: function get() {
    return _DistanceToBeach["default"];
  }
});
Object.defineProperty(exports, "DoneMark", {
  enumerable: true,
  get: function get() {
    return _DoneMark["default"];
  }
});
Object.defineProperty(exports, "Dots", {
  enumerable: true,
  get: function get() {
    return _Dots["default"];
  }
});
Object.defineProperty(exports, "Drink", {
  enumerable: true,
  get: function get() {
    return _Drink["default"];
  }
});
Object.defineProperty(exports, "Error", {
  enumerable: true,
  get: function get() {
    return _Error["default"];
  }
});
Object.defineProperty(exports, "Expand", {
  enumerable: true,
  get: function get() {
    return _Expand["default"];
  }
});
Object.defineProperty(exports, "Filter", {
  enumerable: true,
  get: function get() {
    return _Filter["default"];
  }
});
Object.defineProperty(exports, "Flag", {
  enumerable: true,
  get: function get() {
    return _Flag["default"];
  }
});
Object.defineProperty(exports, "Gift", {
  enumerable: true,
  get: function get() {
    return _Gift["default"];
  }
});
Object.defineProperty(exports, "Googleplay", {
  enumerable: true,
  get: function get() {
    return _Googleplay["default"];
  }
});
Object.defineProperty(exports, "Heart", {
  enumerable: true,
  get: function get() {
    return _Heart["default"];
  }
});
Object.defineProperty(exports, "Help", {
  enumerable: true,
  get: function get() {
    return _Help["default"];
  }
});
Object.defineProperty(exports, "Hot", {
  enumerable: true,
  get: function get() {
    return _Hot["default"];
  }
});
Object.defineProperty(exports, "Hotel", {
  enumerable: true,
  get: function get() {
    return _Hotel["default"];
  }
});
Object.defineProperty(exports, "Huawei", {
  enumerable: true,
  get: function get() {
    return _Huawei["default"];
  }
});
Object.defineProperty(exports, "Information", {
  enumerable: true,
  get: function get() {
    return _Information["default"];
  }
});
Object.defineProperty(exports, "Instant", {
  enumerable: true,
  get: function get() {
    return _Instant["default"];
  }
});
Object.defineProperty(exports, "InsuranceOff", {
  enumerable: true,
  get: function get() {
    return _InsuranceOff["default"];
  }
});
Object.defineProperty(exports, "InsuranceOn", {
  enumerable: true,
  get: function get() {
    return _InsuranceOn["default"];
  }
});
Object.defineProperty(exports, "Job", {
  enumerable: true,
  get: function get() {
    return _Job["default"];
  }
});
Object.defineProperty(exports, "Keys", {
  enumerable: true,
  get: function get() {
    return _Keys["default"];
  }
});
Object.defineProperty(exports, "Like", {
  enumerable: true,
  get: function get() {
    return _Like["default"];
  }
});
Object.defineProperty(exports, "Loader", {
  enumerable: true,
  get: function get() {
    return _Loader["default"];
  }
});
Object.defineProperty(exports, "LogoFullEng", {
  enumerable: true,
  get: function get() {
    return _LogoFullEng["default"];
  }
});
Object.defineProperty(exports, "LogoFullRus", {
  enumerable: true,
  get: function get() {
    return _LogoFullRus["default"];
  }
});
Object.defineProperty(exports, "LogoShortEng", {
  enumerable: true,
  get: function get() {
    return _LogoShortEng["default"];
  }
});
Object.defineProperty(exports, "LogoShortRus", {
  enumerable: true,
  get: function get() {
    return _LogoShortRus["default"];
  }
});
Object.defineProperty(exports, "Logout", {
  enumerable: true,
  get: function get() {
    return _Logout["default"];
  }
});
Object.defineProperty(exports, "Luggage", {
  enumerable: true,
  get: function get() {
    return _Luggage["default"];
  }
});
Object.defineProperty(exports, "Map", {
  enumerable: true,
  get: function get() {
    return _Map["default"];
  }
});
Object.defineProperty(exports, "Meal", {
  enumerable: true,
  get: function get() {
    return _Meal["default"];
  }
});
Object.defineProperty(exports, "Messenger", {
  enumerable: true,
  get: function get() {
    return _Messenger["default"];
  }
});
Object.defineProperty(exports, "Minus", {
  enumerable: true,
  get: function get() {
    return _Minus["default"];
  }
});
Object.defineProperty(exports, "Night", {
  enumerable: true,
  get: function get() {
    return _Night["default"];
  }
});
Object.defineProperty(exports, "Notification", {
  enumerable: true,
  get: function get() {
    return _Notification["default"];
  }
});
Object.defineProperty(exports, "Orders", {
  enumerable: true,
  get: function get() {
    return _Orders["default"];
  }
});
Object.defineProperty(exports, "Pin", {
  enumerable: true,
  get: function get() {
    return _Pin["default"];
  }
});
Object.defineProperty(exports, "Plane", {
  enumerable: true,
  get: function get() {
    return _Plane["default"];
  }
});
Object.defineProperty(exports, "Plus", {
  enumerable: true,
  get: function get() {
    return _Plus["default"];
  }
});
Object.defineProperty(exports, "QuestionFill", {
  enumerable: true,
  get: function get() {
    return _QuestionFill["default"];
  }
});
Object.defineProperty(exports, "QuestionOutline", {
  enumerable: true,
  get: function get() {
    return _QuestionOutline["default"];
  }
});
Object.defineProperty(exports, "Radiobutton18Off", {
  enumerable: true,
  get: function get() {
    return _Radiobutton18Off["default"];
  }
});
Object.defineProperty(exports, "Radiobutton18On", {
  enumerable: true,
  get: function get() {
    return _Radiobutton18On["default"];
  }
});
Object.defineProperty(exports, "Radiobutton24Off", {
  enumerable: true,
  get: function get() {
    return _Radiobutton24Off["default"];
  }
});
Object.defineProperty(exports, "Radiobutton24On", {
  enumerable: true,
  get: function get() {
    return _Radiobutton24On["default"];
  }
});
Object.defineProperty(exports, "Refresh", {
  enumerable: true,
  get: function get() {
    return _Refresh["default"];
  }
});
Object.defineProperty(exports, "Rustore", {
  enumerable: true,
  get: function get() {
    return _Rustore["default"];
  }
});
Object.defineProperty(exports, "Scuba", {
  enumerable: true,
  get: function get() {
    return _Scuba["default"];
  }
});
Object.defineProperty(exports, "Seagull", {
  enumerable: true,
  get: function get() {
    return _Seagull["default"];
  }
});
Object.defineProperty(exports, "Search", {
  enumerable: true,
  get: function get() {
    return _Search["default"];
  }
});
Object.defineProperty(exports, "Service", {
  enumerable: true,
  get: function get() {
    return _Service["default"];
  }
});
Object.defineProperty(exports, "Share", {
  enumerable: true,
  get: function get() {
    return _Share["default"];
  }
});
Object.defineProperty(exports, "Shrink", {
  enumerable: true,
  get: function get() {
    return _Shrink["default"];
  }
});
Object.defineProperty(exports, "Skolkovo", {
  enumerable: true,
  get: function get() {
    return _Skolkovo["default"];
  }
});
Object.defineProperty(exports, "Snow", {
  enumerable: true,
  get: function get() {
    return _Snow["default"];
  }
});
Object.defineProperty(exports, "SortArrows", {
  enumerable: true,
  get: function get() {
    return _SortArrows["default"];
  }
});
Object.defineProperty(exports, "SortDecrease", {
  enumerable: true,
  get: function get() {
    return _SortDecrease["default"];
  }
});
Object.defineProperty(exports, "SortIncrease", {
  enumerable: true,
  get: function get() {
    return _SortIncrease["default"];
  }
});
Object.defineProperty(exports, "Star", {
  enumerable: true,
  get: function get() {
    return _Star["default"];
  }
});
Object.defineProperty(exports, "Success", {
  enumerable: true,
  get: function get() {
    return _Success["default"];
  }
});
Object.defineProperty(exports, "SunHaze", {
  enumerable: true,
  get: function get() {
    return _SunHaze["default"];
  }
});
Object.defineProperty(exports, "Telegram", {
  enumerable: true,
  get: function get() {
    return _Telegram["default"];
  }
});
Object.defineProperty(exports, "Tour", {
  enumerable: true,
  get: function get() {
    return _Tour["default"];
  }
});
Object.defineProperty(exports, "Transfer", {
  enumerable: true,
  get: function get() {
    return _Transfer["default"];
  }
});
Object.defineProperty(exports, "TransferOff", {
  enumerable: true,
  get: function get() {
    return _TransferOff["default"];
  }
});
Object.defineProperty(exports, "TransferOn", {
  enumerable: true,
  get: function get() {
    return _TransferOn["default"];
  }
});
Object.defineProperty(exports, "TriangleDown", {
  enumerable: true,
  get: function get() {
    return _TriangleDown["default"];
  }
});
Object.defineProperty(exports, "TriangleUp", {
  enumerable: true,
  get: function get() {
    return _TriangleUp["default"];
  }
});
Object.defineProperty(exports, "User", {
  enumerable: true,
  get: function get() {
    return _User["default"];
  }
});
Object.defineProperty(exports, "Vk", {
  enumerable: true,
  get: function get() {
    return _Vk["default"];
  }
});
Object.defineProperty(exports, "WifiFree", {
  enumerable: true,
  get: function get() {
    return _WifiFree["default"];
  }
});
Object.defineProperty(exports, "WifiFreeInHoll", {
  enumerable: true,
  get: function get() {
    return _WifiFreeInHoll["default"];
  }
});
Object.defineProperty(exports, "WifiPaidInHollKzt", {
  enumerable: true,
  get: function get() {
    return _WifiPaidInHollKzt["default"];
  }
});
Object.defineProperty(exports, "WifiPaidInHollRub", {
  enumerable: true,
  get: function get() {
    return _WifiPaidInHollRub["default"];
  }
});
Object.defineProperty(exports, "WifiPaidKzt", {
  enumerable: true,
  get: function get() {
    return _WifiPaidKzt["default"];
  }
});
Object.defineProperty(exports, "WifiPaidRub", {
  enumerable: true,
  get: function get() {
    return _WifiPaidRub["default"];
  }
});
Object.defineProperty(exports, "XMark", {
  enumerable: true,
  get: function get() {
    return _XMark["default"];
  }
});
Object.defineProperty(exports, "XMarkCircle", {
  enumerable: true,
  get: function get() {
    return _XMarkCircle["default"];
  }
});
Object.defineProperty(exports, "Youtube", {
  enumerable: true,
  get: function get() {
    return _Youtube["default"];
  }
});
var _Appstore = _interopRequireDefault(require("./Appstore"));
var _ArrowDown = _interopRequireDefault(require("./ArrowDown"));
var _ArrowLeft = _interopRequireDefault(require("./ArrowLeft"));
var _ArrowOnboarding = _interopRequireDefault(require("./ArrowOnboarding"));
var _ArrowRight = _interopRequireDefault(require("./ArrowRight"));
var _ArrowUp = _interopRequireDefault(require("./ArrowUp"));
var _BeachLine = _interopRequireDefault(require("./BeachLine1"));
var _BeachLine2 = _interopRequireDefault(require("./BeachLine2"));
var _BeachLine3 = _interopRequireDefault(require("./BeachLine3"));
var _BeachMixed = _interopRequireDefault(require("./BeachMixed"));
var _BeachPebble = _interopRequireDefault(require("./BeachPebble"));
var _BeachPlatform = _interopRequireDefault(require("./BeachPlatform"));
var _BeachSand = _interopRequireDefault(require("./BeachSand"));
var _BlackClock = _interopRequireDefault(require("./BlackClock"));
var _Burger = _interopRequireDefault(require("./Burger"));
var _CancellationOff = _interopRequireDefault(require("./CancellationOff"));
var _CancellationOn = _interopRequireDefault(require("./CancellationOn"));
var _CancellationQuestion = _interopRequireDefault(require("./CancellationQuestion"));
var _Cashback = _interopRequireDefault(require("./Cashback"));
var _CheckboxOff = _interopRequireDefault(require("./CheckboxOff"));
var _CheckboxOn = _interopRequireDefault(require("./CheckboxOn"));
var _ChevronCompactDown = _interopRequireDefault(require("./ChevronCompactDown"));
var _ChevronCompactLeft = _interopRequireDefault(require("./ChevronCompactLeft"));
var _ChevronCompactRight = _interopRequireDefault(require("./ChevronCompactRight"));
var _ChevronCompactUp = _interopRequireDefault(require("./ChevronCompactUp"));
var _ChevronDown = _interopRequireDefault(require("./ChevronDown"));
var _ChevronLeft = _interopRequireDefault(require("./ChevronLeft"));
var _ChevronRight = _interopRequireDefault(require("./ChevronRight"));
var _ChevronUp = _interopRequireDefault(require("./ChevronUp"));
var _Clock = _interopRequireDefault(require("./Clock"));
var _Company = _interopRequireDefault(require("./Company"));
var _Desktop = _interopRequireDefault(require("./Desktop"));
var _Dislike = _interopRequireDefault(require("./Dislike"));
var _DistanceToBeach = _interopRequireDefault(require("./DistanceToBeach"));
var _DoneMark = _interopRequireDefault(require("./DoneMark"));
var _Dots = _interopRequireDefault(require("./Dots"));
var _Drink = _interopRequireDefault(require("./Drink"));
var _Error = _interopRequireDefault(require("./Error"));
var _Expand = _interopRequireDefault(require("./Expand"));
var _Filter = _interopRequireDefault(require("./Filter"));
var _Flag = _interopRequireDefault(require("./Flag"));
var _Gift = _interopRequireDefault(require("./Gift"));
var _Googleplay = _interopRequireDefault(require("./Googleplay"));
var _Heart = _interopRequireDefault(require("./Heart"));
var _Help = _interopRequireDefault(require("./Help"));
var _Hot = _interopRequireDefault(require("./Hot"));
var _Hotel = _interopRequireDefault(require("./Hotel"));
var _Huawei = _interopRequireDefault(require("./Huawei"));
var _Information = _interopRequireDefault(require("./Information"));
var _Instant = _interopRequireDefault(require("./Instant"));
var _InsuranceOff = _interopRequireDefault(require("./InsuranceOff"));
var _InsuranceOn = _interopRequireDefault(require("./InsuranceOn"));
var _Job = _interopRequireDefault(require("./Job"));
var _Keys = _interopRequireDefault(require("./Keys"));
var _Like = _interopRequireDefault(require("./Like"));
var _Loader = _interopRequireDefault(require("./Loader"));
var _LogoFullEng = _interopRequireDefault(require("./LogoFullEng"));
var _LogoFullRus = _interopRequireDefault(require("./LogoFullRus"));
var _LogoShortEng = _interopRequireDefault(require("./LogoShortEng"));
var _LogoShortRus = _interopRequireDefault(require("./LogoShortRus"));
var _Logout = _interopRequireDefault(require("./Logout"));
var _Luggage = _interopRequireDefault(require("./Luggage"));
var _Map = _interopRequireDefault(require("./Map"));
var _Meal = _interopRequireDefault(require("./Meal"));
var _Messenger = _interopRequireDefault(require("./Messenger"));
var _Minus = _interopRequireDefault(require("./Minus"));
var _Night = _interopRequireDefault(require("./Night"));
var _Notification = _interopRequireDefault(require("./Notification"));
var _Orders = _interopRequireDefault(require("./Orders"));
var _Pin = _interopRequireDefault(require("./Pin"));
var _Plane = _interopRequireDefault(require("./Plane"));
var _Plus = _interopRequireDefault(require("./Plus"));
var _QuestionFill = _interopRequireDefault(require("./QuestionFill"));
var _QuestionOutline = _interopRequireDefault(require("./QuestionOutline"));
var _Radiobutton18Off = _interopRequireDefault(require("./Radiobutton18Off"));
var _Radiobutton18On = _interopRequireDefault(require("./Radiobutton18On"));
var _Radiobutton24Off = _interopRequireDefault(require("./Radiobutton24Off"));
var _Radiobutton24On = _interopRequireDefault(require("./Radiobutton24On"));
var _Refresh = _interopRequireDefault(require("./Refresh"));
var _Rustore = _interopRequireDefault(require("./Rustore"));
var _Scuba = _interopRequireDefault(require("./Scuba"));
var _Seagull = _interopRequireDefault(require("./Seagull"));
var _Search = _interopRequireDefault(require("./Search"));
var _Service = _interopRequireDefault(require("./Service"));
var _Share = _interopRequireDefault(require("./Share"));
var _Shrink = _interopRequireDefault(require("./Shrink"));
var _Skolkovo = _interopRequireDefault(require("./Skolkovo"));
var _Snow = _interopRequireDefault(require("./Snow"));
var _SortArrows = _interopRequireDefault(require("./SortArrows"));
var _SortDecrease = _interopRequireDefault(require("./SortDecrease"));
var _SortIncrease = _interopRequireDefault(require("./SortIncrease"));
var _Star = _interopRequireDefault(require("./Star"));
var _Success = _interopRequireDefault(require("./Success"));
var _SunHaze = _interopRequireDefault(require("./SunHaze"));
var _Telegram = _interopRequireDefault(require("./Telegram"));
var _Tour = _interopRequireDefault(require("./Tour"));
var _TransferOff = _interopRequireDefault(require("./TransferOff"));
var _TransferOn = _interopRequireDefault(require("./TransferOn"));
var _Transfer = _interopRequireDefault(require("./Transfer"));
var _TriangleDown = _interopRequireDefault(require("./TriangleDown"));
var _TriangleUp = _interopRequireDefault(require("./TriangleUp"));
var _User = _interopRequireDefault(require("./User"));
var _Vk = _interopRequireDefault(require("./Vk"));
var _WifiFreeInHoll = _interopRequireDefault(require("./WifiFreeInHoll"));
var _WifiFree = _interopRequireDefault(require("./WifiFree"));
var _WifiPaidInHollKzt = _interopRequireDefault(require("./WifiPaidInHollKzt"));
var _WifiPaidInHollRub = _interopRequireDefault(require("./WifiPaidInHollRub"));
var _WifiPaidKzt = _interopRequireDefault(require("./WifiPaidKzt"));
var _WifiPaidRub = _interopRequireDefault(require("./WifiPaidRub"));
var _XMarkCircle = _interopRequireDefault(require("./XMarkCircle"));
var _XMark = _interopRequireDefault(require("./XMark"));
var _Youtube = _interopRequireDefault(require("./Youtube"));